import { render, staticRenderFns } from "./Funds.vue?vue&type=template&id=6d386c1c&"
import script from "./Funds.vue?vue&type=script&lang=js&"
export * from "./Funds.vue?vue&type=script&lang=js&"
import style0 from "./Funds.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports